import { FC, Fragment, useMemo } from "react";
import { Grid } from "@mui/material";
import { SchedulePreviewSectionTitle } from "./SchedulePreviewSectionTitle";
import { SchedulePreviewTable } from "./SchedulePreviewTable";
import { SchedulePreviewNameRow } from "./SchedulePreviewNameRow";
import { SchedulePreviewAccounts } from "./SchedulePreviewAccounts";
import { SchedulePreviewRegions } from "./SchedulePreviewRegions";
import { ProviderType } from "../../../../../../services/cloudchipr.api";

interface SchedulePreviewEnvironmentProps {
  name: string;
  provider: ProviderType;
  accountIds: string[];
  regions: string[];
  onFieldChange(key: string, value: any): void;
}

export const SchedulePreviewEnvironment: FC<
  SchedulePreviewEnvironmentProps
> = ({ name, accountIds, regions, provider, onFieldChange }) => {
  const data = useMemo(() => {
    return [
      {
        title: "Cloud Provider",
        label: provider?.toUpperCase() || "",
      },
      {
        title: "Cloud Account/s",
        label: (
          <SchedulePreviewAccounts
            accountIds={accountIds}
            provider={provider}
          />
        ),
      },
      {
        title: "Region/s",
        label: <SchedulePreviewRegions regions={regions} provider={provider} />,
      },
    ];
  }, [provider, regions, accountIds]);

  return (
    <Fragment>
      <SchedulePreviewSectionTitle title="Selected Environment" />

      <Grid container>
        <Grid item xs={12} md={12}>
          <SchedulePreviewTable data={data}>
            <SchedulePreviewNameRow
              title="Name"
              label={name}
              onFieldChange={onFieldChange}
            />
          </SchedulePreviewTable>
        </Grid>
      </Grid>
    </Fragment>
  );
};
